import { getAuthStore, getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class PerformanceEvaluationsProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('performance-evaluations', query)
  }

  getItemByWarehouseId (id, month, year) {
    this.setHeader(getAuthToken())
    return this.get(`performance-evaluations/${id}/warehouse?month=${month}&year=${year}`)
  }

  snapshotEvaluation (query) {
    this.setHeader(getAuthToken())
    return this.get(`/public/${getAuthStore().id}/performance-evaluations`, query)
  }
}

export default PerformanceEvaluationsProvider
